<!--
  Panel "Algoritmo" del detalle del arrendamiento (ADR-0031, Fase D).
  Toda la UI vive en `app-ciec-analysis-view` (shared) para reuso con
  `customer-detail`. Aquí solo conectamos al snapshot del lease + la regla
  de mutabilidad por estado.
-->
<!--
  B-004 · Este componente tiene su propio MessageService y el único p-toast de abajo (`ciec-analysis-view`) filtra por
  su clave: sin este, los avisos de copiar, verificar y Ekatena no se veían nunca.
-->
<p-toast position="top-right"></p-toast>

<!-- B-004 · El análisis del arrendamiento vino vacío o no existe: copiar el del cliente, actualizar datos o pedir la CIEC. -->
<div class="aviso-copia" *ngIf="copyBanner as aviso" role="status" data-test="copy-banner">
  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
  <div class="aviso-copia__cuerpo">
    <strong>{{ aviso.title }}</strong>
    <span>{{ aviso.text }}</span>
  </div>
  <ng-container [ngSwitch]="aviso.action">
    <ng-container *ngSwitchCase="'copy'">
      <button
        *appIfHasPermission="['leases', 'update']"
        pButton
        type="button"
        class="p-button-sm"
        icon="fa-solid fa-copy"
        label="Copiar del cliente"
        data-test="copy-from-client"
        [loading]="copying"
        [disabled]="copying"
        (click)="onCopyBannerAction('copy')"
      ></button>
    </ng-container>
    <ng-container *ngSwitchCase="'refresh'">
      <button
        *appIfHasPermission="['leases', 'update']"
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-rotate"
        label="Actualizar datos"
        data-test="refresh-from-banner"
        [loading]="isRunningVerification"
        [disabled]="isRunningVerification"
        (click)="onCopyBannerAction('refresh')"
      ></button>
    </ng-container>
    <ng-container *ngSwitchCase="'request'">
      <button
        *appIfHasPermission="['clients', 'update']"
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-envelope"
        label="Solicitar CIEC"
        data-test="request-ciec"
        (click)="onCopyBannerAction('request')"
      ></button>
    </ng-container>
    <a *ngSwitchCase="'go-to-client'" class="aviso-copia__enlace" [routerLink]="['/customer', clientId]" data-test="go-to-client"
      >Ir a la ficha del cliente</a
    >
  </ng-container>
</div>

<app-ciec-request-dialog
  *ngIf="copyBanner?.action === 'request'"
  [(visible)]="showCiecRequestDialog"
  [clientId]="clientId"
  [clientEmail]="client?.email || ''"
  [clientName]="clientName"
  [ciecStatus]="copyPreview?.clientCiec ?? null"
  (changed)="loadCopyPreview()"
></app-ciec-request-dialog>

<app-ciec-analysis-view
  [verification]="verificationData"
  mode="lease-snapshot"
  [canRefresh]="canRefreshLeaseSnapshot"
  [refreshing]="isRunningVerification"
  [refreshDisabledReason]="refreshDisabledReason"
  [ekatenaReport]="ekatenaReport"
  [ekatenaBuscando]="ekatenaBuscando"
  [ekatenaImportando]="ekatenaImportando"
  [snapshotContext]="snapshotContext"
  [initialSubtab]="initialSubtab"
  (importEkatena)="importarEkatena()"
  (refresh)="runVerification()"
>
</app-ciec-analysis-view>
